export const enrolmentCardVisibilityList = [
  'excel',
  'exploration',
  'membership',
  'event',
  'explore'
]

export const enrolmentCardProgramList = [
  'excel',
  'exploration',
  'membership',
  'school',
  'care'
]

export const enrolmentCardEventList = ['event']

export const enrolmentCardTrialList = ['explore']
